import { createSlice } from "@reduxjs/toolkit";

/** Optional cache of items-gallery basenames per bizId (manifest is source of truth). */
const initialState = {
  byBizId: {},
  /** Optional local mirror of hub display image key (also persisted via `updateHubDetails`). */
  hubImageKey: null,
  /**
   * CDN manifest + image cache busting per storage path prefix (mediaPath output).
   * `imageCacheNonce` increments when new bytes are written at the same S3 key so image URLs change.
   */
  manifestByPathPrefix: {},
};

const gallerySlice = createSlice({
  name: "gallery",
  initialState,
  reducers: {
    setGalleryKeysForBiz(state, action) {
      const { bizId, keys } = action.payload;
      if (!bizId) return;
      state.byBizId[bizId] = Array.isArray(keys) ? keys : [];
    },
    addGalleryKeyForBiz(state, action) {
      const { bizId, imageKey } = action.payload;
      if (!bizId || !imageKey) return;
      const cur = state.byBizId[bizId] || [];
      if (!cur.includes(imageKey)) {
        state.byBizId[bizId] = [...cur, imageKey];
      }
    },
    setHubImageKey(state, action) {
      state.hubImageKey = action.payload ?? null;
    },
    setGalleryManifestForPath(state, action) {
      const { pathPrefix, manifest, bumpImageCache } = action.payload;
      if (!pathPrefix) return;
      const prev = state.manifestByPathPrefix[pathPrefix] || {
        manifest: { version: 1, images: [] },
        imageCacheNonce: 0,
      };
      state.manifestByPathPrefix[pathPrefix] = {
        manifest: manifest || { version: 1, images: [] },
        imageCacheNonce: bumpImageCache
          ? prev.imageCacheNonce + 1
          : prev.imageCacheNonce,
      };
    },
    clearGalleryManifestForPath(state, action) {
      const pathPrefix = action.payload;
      if (pathPrefix != null && pathPrefix !== "" && state.manifestByPathPrefix[pathPrefix]) {
        delete state.manifestByPathPrefix[pathPrefix];
      }
    },
  },
});

export const {
  setGalleryKeysForBiz,
  addGalleryKeyForBiz,
  setHubImageKey,
  setGalleryManifestForPath,
  clearGalleryManifestForPath,
} = gallerySlice.actions;
export default gallerySlice.reducer;
